import React, { ComponentType, useEffect, useState } from 'react';

import { allPagesRoutes } from 'router/publicRoutesMap';

import { replaceUnderscoreToDash } from 'helpers/other/transformationUtils';

import type { WithPreloadNextPageProps } from 'types/onboarding/onboarding';

const withPreloadNextPage = <P extends WithPreloadNextPageProps>(Component: ComponentType<P>): ComponentType<P> => {
    const WrappedComponent = (props: P) => {
        const [nextPageId, setNextPageId] = useState<string | null>(null);

        useEffect(() => {
            getNextPageInfo(setNextPageId);
        }, []);

        useEffect(() => {
            let timerId: ReturnType<typeof setTimeout>;

            if (nextPageId) {
                const actualRoute = allPagesRoutes.find((item) => item.route === nextPageId);

                timerId = setTimeout(() => {
                    import(`../pages/${actualRoute?.path}`).catch((error) => {
                        console.error(`PRELOAD FAILED: ${error?.message}`);
                    });
                }, 0);
            }

            return () => clearInterval(timerId);
        }, [nextPageId]);

        async function getNextPageInfo(cb: (nextPageId: string | null) => void) {
            const nextPageInfo = await props?.getNextPage?.();

            nextPageInfo && cb(replaceUnderscoreToDash(nextPageInfo?.id));
        }

        return <Component {...props} nextPageId={nextPageId} />;
    };

    WrappedComponent.displayName = `withPreloadNextPage(${Component.displayName || Component.name})`;

    return WrappedComponent;
};

export default withPreloadNextPage;
